import { commonTranslationKeys, FieldControllerProps } from '@dreryk/react-common';
import { ClassNameProp, TextInput } from '@dreryk/react-components';

const STREET_MAX_LENGTH = 50;

type StreetInputProps = FieldControllerProps<'street', string | null> & ClassNameProp;

export const StreetInput = (props: StreetInputProps): JSX.Element => {
   const controller = props.register(props.name, {
      required: props.required,
      maxLength: STREET_MAX_LENGTH,
   });

   return (
      <TextInput
         testId={props.name}
         label={commonTranslationKeys.addressData.street}
         controller={controller}
         defaultValue={props.defaultValue}
         className={props.className}
      />
   );
};
